import React from "react";

const AppListIcons = ({ height = 24, width = 24, color = "#000" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.324 1.51746C16 1.50004 16 1.50004 16.676 1.51746H28C28.4072 1.75702 28.6573 2.19422 28.6573 2.66671V29.3334C28.6573 29.8059 28.4072 30.2431 28 30.4826H16.676C16 30.5 16 30.5 15.324 30.4826H3.99064C3.58339 30.2431 3.33334 29.8059 3.33334 29.3334L3.33334 2.66671C3.33334 2.19422 3.58339 1.75702 3.99064 1.51746L15.324 1.51746ZM6 4.21362V27.7865H16H26.5V4.21362H16H6Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23 21.3333C23 22.0696 22.403 22.6666 21.6667 22.6666L10 22.6666C9.26362 22.6666 8.66667 22.0696 8.66667 21.3333C8.66667 20.5969 9.26362 19.9999 10 19.9999L21.6667 19.9999C22.403 19.9999 23 20.5969 23 21.3333ZM23 15.9999C23 16.7363 22.403 17.3333 21.6667 17.3333L10 17.3333C9.26362 17.3333 8.66667 16.7363 8.66667 15.9999C8.66667 15.2635 9.26362 14.6666 10 14.6666L21.6667 14.6666C22.403 14.6666 23 15.2635 23 15.9999ZM23 10.6666C23 11.403 22.403 11.9999 21.6667 11.9999L10 11.9999C9.26362 11.9999 8.66667 11.403 8.66667 10.6666C8.66667 9.93021 9.26362 9.33325 10 9.33325L21.6667 9.33325C22.403 9.33325 23 9.93021 23 10.6666Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default AppListIcons;
